import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text, View } from 'react-native'
import { tv } from 'tailwind-variants'

import { useFlowsServicesResponses } from '@flows-ui/services/FlowServicesResponsesContext'
import { processStepContentElementText } from '@flows-ui/utils/processStepContentElementText'
import type { TextContent } from '@flows/core/i18n/types'
import type { FlowValues } from '@flows/core/types/stepTypes'
import { IMAGE } from '@ui-kit/assets/images/index.native'
import ButtonIcon from '@ui-kit/components/ButtonIcon'
import Icon from '@ui-kit/components/SvgIcon'
import { body2 } from '@ui-kit/core/typography'

type Props = {
  onPress: () => void
  type: 'add' | 'remove'
  title: TextContent
  flowValues: FlowValues
  testID: string
}

const buttonStyles = tv({
  slots: {
    container: 'flex-row items-center justify-end pb-4',
  },
  variants: {
    isAdd: {
      true: {
        container: 'justify-start',
      },
    },
  },
})

export const EditableSetButton = (props: Props) => {
  const { t } = useTranslation()
  const servicesResponses = useFlowsServicesResponses()
  const translateFunction = processStepContentElementText(t, {
    flowValues: props.flowValues,
    servicesResponses,
  })
  const { container } = buttonStyles({ isAdd: props.type === 'add' })

  return (
    <View className={container()}>
      <Text className={body2()}>{translateFunction(props.title)}</Text>
      <ButtonIcon
        testID={props.testID}
        icon={
          <Icon
            imgSrc={
              props.type === 'add'
                ? IMAGE.icons.small.circlePlus_24
                : IMAGE.icons.small.circleMinus_24
            }
          />
        }
        onPress={props.onPress}
      />
    </View>
  )
}

export default EditableSetButton
